import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { blockUi, addHeader } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { RetornoMensagemSimplesDTO } from "src/app/model/questionario.model";
import { EntradaRemuneracaoCentralDTO, EntradaRemuneracaoRepasseDTO, EntradaRemuneracaoCreditoLivreDTO, RespostaRemuneracao } from "src/app/model/remuneracao.model";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";

@Injectable({
  providedIn: "root",
})
export class TarefasRemuneracaoService extends FgiBackEndService<any> {
  getNewEntity() {
    return null;
  }

  protected getResourceURL(): string {
    return "front/tarefas/remuneracao";
  }

  buscarDescricaoTaxaAtualizacaoGarantia(idOperacao: number): Observable<RetornoMensagemSimplesDTO> {
    return this.http.get(`${this.BASE_URL}/central-remuneracao/descricao-taxa-atualizacao-garantia/operacao/${idOperacao}`).pipe(
      catchError((e) => this.handleError(e))) as Observable<RetornoMensagemSimplesDTO>;
  }

  buscarDataUltimaCotacaoSelicCarregada(): Observable<Date> {
    return this.http.get(`${this.BASE_URL}/data-ultima-cotacao-selic-carregada`).pipe(
      catchError((e) => this.handleError(e))) as Observable<Date>;
  }
 
  remunerarPorCentralRemuneracao(dto: EntradaRemuneracaoCentralDTO): Observable<RespostaRemuneracao> {
    const options: any = blockUi();
    return this.http
      .post(`${this.BASE_URL}/central-remuneracao/solicitar-e-remunerar`, dto, options)
      .pipe(catchError((e) => this.handleError(e))) as Observable<RespostaRemuneracao>;
  }

  remunerarCreditoLivre(dados: EntradaRemuneracaoCreditoLivreDTO): Observable<number> {
    let params = new HttpParams();
    Object.keys(dados).forEach((key) => {
      if (dados[key] != null) {
        params = params.append(key, dados[key]);
      }
    });
    const options: any = blockUi();
    return this.http
      .get<number>(`${this.BASE_URL}/remunerar-credito-livre`, { ...options, params })
      .pipe(catchError((e) => this.handleError(e))) as Observable<number>;
  }

  remunerarRepasse(params: EntradaRemuneracaoRepasseDTO): Observable<RespostaRemuneracao> {
    const options: any = blockUi();
    return this.http
      .get<RespostaRemuneracao>(`${this.BASE_URL}/remunerar-repasse`, { ...options, params })
      .pipe(catchError((e) => this.handleError(e))) as Observable<RespostaRemuneracao>;
  }

  public criarSolicitacaoRemuneracaoPorJson(conteudoJson: string): Observable<any> {
    let  options: any = blockUi();
    addHeader(options, 'Content-Type', 'application/json');
    return this.http
      .post(
        `${this.BASE_URL}/central-remuneracao/solicitar`,
        conteudoJson,
        options
      )
      .pipe(catchError((e) => this.handleError(e))) as Observable<any>;
  }

  habilitar(): Observable<String> {
    const options: any = blockUi();
    return this.http
      .post<String>(
        `${this.BASE_URL}/central-remuneracao/remunerar/habilitar-dsv`,
        {
          ...options,
        },
      )
      .pipe(catchError((e) => this.handleError(e))) as Observable<String>;
  }

  desabilitar(): Observable<String> {
    const options: any = blockUi();
    return this.http
      .post<String>(
        `${this.BASE_URL}/central-remuneracao/remunerar/desabilitar-dsv`,
        {
          ...options,
        },
      )
      .pipe(catchError((e) => this.handleError(e))) as Observable<String>;
  }
}
